import React, { useState, useEffect } from "react";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import "./TableIncomeAndExpenses.css";
import { BsCardList } from "react-icons/bs";
import axios from "axios";
import Swal from "sweetalert2";

const TableIncomeAndExpenses = ({ data, reloadData }) => {
  const [incomeAndExpensesData, setIncomeAndExpensesData] = useState([]);
  const [incomeAndExpenseTotal, setIncomeAndExpenseTotal] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const userId = data && data.id ? data.id : null;
  useEffect(() => {
    if (userId !== null) {
      // Construye la URL de la solicitud GET con el ID del usuario y las fechas
      const apiUrl = `${process.env.REACT_APP_LEALTAD_INCOME_AND_EXPENSES}?userId=${userId}`;

      // Realiza la solicitud GET al backend para obtener los datos de ingresos y egresos
      const fetchData = async () => {
        try {
          const response = await axios.get(apiUrl);
          if (response.status === 404) {
            // Actualizar el estado de ingresos y egresos a un arreglo vacío
            setIncomeAndExpensesData([]);
            setIncomeAndExpenseTotal([]);
          } else {
            setIncomeAndExpensesData(response.data.userIncomeAndExpenses);
            setIncomeAndExpenseTotal(response.data.userTotal.totalBalance);
          }
        } catch (error) {
          setIncomeAndExpensesData([]);
          setIncomeAndExpenseTotal([]);
        }
      };

      // Llama a la función fetchData cuando el componente se monta
      fetchData();
    }
  }, [data, userId, reloadData]);

  const handleFilterButtonClick = () => {
    if (userId !== null) {
      // Realiza la solicitud GET al backend cuando se hace clic en el botón de filtro
      const apiUrl = `${process.env.REACT_APP_LEALTAD_INCOME_AND_EXPENSES}?userId=${userId}&from=${fromDate}&to=${toDate}`;

      const fetchData = async () => {
        try {
          const response = await axios.get(apiUrl);
          setIncomeAndExpensesData(response.data.userIncomeAndExpenses);
          setIncomeAndExpenseTotal(response.data.userTotal);
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo un error al intentar cargar los Pagos/Cobros del usuario.",
          });
        }
      };

      fetchData();
    }
  };

  return (
    <div className="all_newig_eg2-lealtad">
      <h2 className="tittle_ig_eg-lealtad">Todos los Pagos y Cobros</h2>
      <div className="flexdateinputig_eg-lealtad">
        <div className="collumndate_ig_eg-lealtad">
          <label htmlFor="fromDate" className="label_ig_eg-lealtad">
            Fecha de inicio
          </label>
          <input
            className="inputdate_ig_eg-lealtad"
            type="date"
            id="fromDate"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="collumndate_ig_eg-lealtad">
          <label htmlFor="toDate" className="label_ig_eg-lealtad">
            Fecha de finalizacion
          </label>
          <input
            className="inputdate_ig_eg-lealtad"
            type="date"
            id="toDate"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <button
          className="button_date_search_ig_eg-lealtad"
          onClick={handleFilterButtonClick}
        >
          Filtrar
        </button>
      </div>
      {incomeAndExpensesData.length === 0 ? (
        <NotReportViewData
          title="Lo sentimos pero no hay Pagos ni Cobros que mostrar"
          Icon={BsCardList}
        />
      ) : (
        <>
          <div className="list_reports_ig_eg2-lealtad">
            <h2 className="tittle_ig_eg-lealtad">Todos los Pagos y Cobros</h2>
            <div className="scrool_ig_eg-lealtad">
              {incomeAndExpensesData.map((item, index) => (
                <div className="reports_ig_eg-lealtad" key={index}>
                  <div className="width_ig_ig_eg first_three-lealtad">
                    <p className="ig_eg_p_data-lealtad">
                      {item.incomeAndExpenses}
                    </p>
                  </div>
                  <div className="width_ig_ig_eg first_three-lealtad">
                    <p className="ig_eg_p_data-lealtad">{item.createAt}</p>
                  </div>
                  <div className="width_ig_ig_eg first_three-lealtad">
                    <p className="ig_eg_p_data-lealtad">{"$" + item.amount}</p>
                  </div>
                  <div className="width_ig_ig_eg-lealtad">
                    <p className="ig_eg_p_data-lealtad">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="total_ig_eg-lealtad">
              <div className="ig_eg_total-lealtad">
                <p className="ig_eg_p_data-lealtad">
                  Monto Total: {incomeAndExpenseTotal}
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TableIncomeAndExpenses;
